<!--Main Panel-->
<div>
	<!--Main Menu-->
	<div class="scst-Menu">
		<h5>ScanStation Options:</h5>

		<!--Checkbox grid-->
		<div class="scst-Grid2Col">
			<input
				[disabled]="IsLoading() == true"
				class="CHK"
				id="TimeScanningMode"
				type="checkbox"
				[(ngModel)]="optionsData.TimeScanningMode"
				*ngIf="DistrictUser()"
			/>
			<div class="scst-Flex" *ngIf="DistrictUser()">
				<label class="scst-LabelText" for="TimeScanningMode">Time Scanning Mode Enabled</label>
				<label class="scst-HelpTextInline" for="TimeScanningMode">(This effects the whole district)</label>
			</div>

			<input [disabled]="IsLoading() == true" class="CHK" id="PrintLatePassIfTardy" type="checkbox" [(ngModel)]="optionsData.PrintLatePassIfTardy" />
			<label class="scst-LabelText" for="PrintLatePassIfTardy">Print Late Pass if Tardy</label>

			<input [disabled]="IsLoading() == true" class="CHK" id="PrintPicOnLatePass" type="checkbox" [(ngModel)]="optionsData.PrintPicOnLatePass" />
			<label class="scst-LabelText" for="PrintPicOnLatePass">Print Pictures on Late Passes</label>

			<input
				[disabled]="DistrictUser() == false || IsLoading() == true"
				class="CHK"
				id="StationPassEnable"
				type="checkbox"
				[(ngModel)]="optionsData.StationPassEnable"
			/>
			<div class="scst-Flex">
				<label class="scst-LabelText" for="StationPassEnable">Print Custom Fields on Entry/Tardy Passes</label>
				<label class="scst-HelpTextInline" for="StationPassEnable">(This effects the whole district)</label>
			</div>

			<input [disabled]="IsLoading() == true" class="CHK" id="ShowScheduleOnLatePass" type="checkbox" [(ngModel)]="optionsData.ShowScheduleOnLatePass" />
			<label class="scst-LabelText" for="ShowScheduleOnLatePass">Always Show Schedule on Late Pass and Temporary ID</label>

			<input [disabled]="IsLoading() == true" class="CHK" id="PrintScheduleInLunch" type="checkbox" [(ngModel)]="optionsData.PrintScheduleInLunch" />
			<label class="scst-LabelText" for="PrintScheduleInLunch">Always Print Schedule in Lunch Scanning</label>

			<input [disabled]="IsLoading() == true" class="CHK" id="PrintStudentCutReport" type="checkbox" [(ngModel)]="optionsData.PrintStudentCutReport" />
			<label class="scst-LabelText" for="PrintStudentCutReport">Print Student Cut Report</label>

			<input [disabled]="IsLoading() == true" class="CHK" id="CourseScanningEnabled" type="checkbox" [(ngModel)]="optionsData.CourseScanningEnabled" />
			<label class="scst-LabelText" for="CourseScanningEnabled">Course Scanning Enabled</label>

			<input
				[disabled]="IsLoading() == true"
				class="CHK"
				id="EnableOutOfUniformCheck"
				type="checkbox"
				[(ngModel)]="optionsData.EnableOutOfUniformCheck"
			/>
			<label class="scst-LabelText" for="EnableOutOfUniformCheck">Enable Out of Uniform Check</label>
		</div>

		<div class="scst-Grid2Col" style="margin-top: 15px">
			<label class="scst-LabelText" style="word-wrap: break-word; max-width: 120px">Out of Uniform Check Default Penalty:</label>
			<select
				class="form-control scst-LabelText"
				name="DefaultPenalty"
				[(ngModel)]="optionsData.DefaultPenaltyID"
				[disabled]="IsLoading() == true || optionsData.EnableOutOfUniformCheck == false"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of PenaltyList" [ngValue]="o.PenaltyID" style="color: black">
					{{ o.PenaltyDesc }}
				</option>
			</select>

			<label class="scst-LabelText">Default Tardy Reason:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control scst-LabelText"
				name="DefaultTardyReason"
				[(ngModel)]="optionsData.DefaultTardyReason"
				[style.color]="optionsData.DefaultTardyReason.Active == true ? 'Black' : 'Red'"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of ExcuseList" [ngValue]="o" [style.color]="o.Active == true ? 'Black' : 'Red'">
					{{ o.ExcuseCD }} - {{ o.ExcuseDesc }}
				</option>
			</select>

			<!--
			<label class="scst-LabelText">Default Exit Reason:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control scst-LabelText"
				name="DefaultExitReason"
				[(ngModel)]="optionsData.DefaultExitReason"
				[style.color]="optionsData.DefaultExitReason.Active == true ? 'Black' : 'Red'"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of ExcuseList" [ngValue]="o" [style.color]="o.Active == true ? 'Black' : 'Red'">
					{{ o.ExcuseCD }} - {{ o.ExcuseDesc }}
				</option>
			</select>
			-->

			<label class="scst-LabelText">Default Absent Reason:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control scst-LabelText"
				name="DefaultAbsentReason"
				[(ngModel)]="optionsData.DefaultAbsentReason"
				[style.color]="optionsData.DefaultAbsentReason.Active == true ? 'Black' : 'Red'"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of ExcuseList" [ngValue]="o" [style.color]="o.Active == true ? 'Black' : 'Red'">
					{{ o.ExcuseCD }} - {{ o.ExcuseDesc }}
				</option>
			</select>
		</div>

		<div class="scst-Grid2Col" style="margin-top: 15px">
			<label class="scst-LabelText">Custom Fields to Print:</label>
			<div class="scst-CustomFieldGrid">
				<ng-container *ngFor="let o of lstStationPass">
					<input
						[disabled]="DistrictUser() == false || optionsData.StationPassEnable != true || IsLoading() == true"
						[id]="o.ID"
						type="checkbox"
						class="CHK"
						[(ngModel)]="o.IsEnabled"
					/>
					<label class="scst-LabelText" [for]="o.ID">{{ o.FieldDesc }}</label>
				</ng-container>
			</div>
		</div>
	</div>

	<!--Sound Menu-->
	<div class="scst-Menu">
		<h5>Valid Scan Sound:</h5>

		<!--Options-->
		<div class="scst-Grid2Row">
			<!--Sound options-->
			<div class="scst-Grid2Col">
				<select
					[disabled]="IsLoading() == true"
					class="form-control scst-LabelText"
					name="ValidScanSoundFile"
					(ngModelChange)="onSoundChange()"
					[(ngModel)]="optionsData.ValidScanSoundFile"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of SoundList" [ngClass]="o.SchoolID > 0 ? 'scst-SchoolStyle' : 'scst-DistrictStyle'" [ngValue]="o.SoundFile">
						{{ o.SoundFile }}
					</option>
				</select>

				<div>
					<!-- <button class="btn btn-primary scst-LabelText" (click)="openSoundMaintenance()">...</button> -->
					<button class="btn btn-primary scst-LabelText" (click)="PlaySoundValidScan()">Play</button>
					<button class="btn btn-primary scst-LabelText" (click)="StopSound()">Stop</button>
					<button class="btn btn-primary scst-LabelText" (click)="ClearValidScanSound()">Clear</button>
				</div>
			</div>
		</div>

		<h5>Student Already In Sound:</h5>

		<!--Options-->
		<div class="scst-Grid2Row">
			<!--Sound options-->
			<div class="scst-Grid2Col">
				<select
					[disabled]="IsLoading() == true"
					class="form-control scst-LabelText"
					name="SoundFile"
					(ngModelChange)="onSoundChange()"
					[(ngModel)]="optionsData.SoundFile"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of SoundList" [ngClass]="o.SchoolID > 0 ? 'scst-SchoolStyle' : 'scst-DistrictStyle'" [ngValue]="o.SoundFile">
						{{ o.SoundFile }}
					</option>
				</select>

				<div>
					<!-- <button class="btn btn-primary scst-LabelText" (click)="openSoundMaintenance()">...</button> -->
					<button class="btn btn-primary scst-LabelText" (click)="PlaySoundStudentAlreadyIn()">Play</button>
					<button class="btn btn-primary scst-LabelText" (click)="StopSound()">Stop</button>
					<button class="btn btn-primary scst-LabelText" (click)="ClearSound()">Clear</button>
				</div>
			</div>

			<!--Help Text-->
			<div>
				<p class="scst-HelpText">
					Note: The 'Student Already In Sound' above sets the sound to play when a student attempts to enter the school after already being admitted
					for the day.
				</p>
			</div>
		</div>

		<h5>Early Exit Sound (Unexcused):</h5>
		<div class="scst-Grid2Row">
			<!--Sound options-->
			<div class="scst-Grid2Col">
				<select
					[disabled]="IsLoading() == true"
					class="form-control scst-LabelText"
					name="EarlyExitUnexcusedSoundFile"
					(ngModelChange)="onSoundChange()"
					[(ngModel)]="optionsData.EarlyExitUnexcusedSoundFile"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of SoundList" [ngClass]="o.SchoolID > 0 ? 'scst-SchoolStyle' : 'scst-DistrictStyle'" [ngValue]="o.SoundFile">
						{{ o.SoundFile }}
					</option>
				</select>

				<div>
					<!-- <button class="btn btn-primary scst-LabelText" (click)="openSoundMaintenance()">...</button> -->
					<button class="btn btn-primary scst-LabelText" (click)="PlaySoundEarlyExitUnexcused()">Play</button>
					<button class="btn btn-primary scst-LabelText" (click)="StopSound()">Stop</button>
					<button class="btn btn-primary scst-LabelText" (click)="ClearEarlyExitUnexcusedSound()">Clear</button>
				</div>
			</div>
		</div>

		<h5>Early Exit Sound (Excused because of Release Schedule):</h5>
		<div class="scst-Grid2Row">
			<!--Sound options-->
			<div class="scst-Grid2Col">
				<select
					[disabled]="IsLoading() == true"
					class="form-control scst-LabelText"
					name="EarlyExitExcusedSoundFile"
					(ngModelChange)="onSoundChange()"
					[(ngModel)]="optionsData.EarlyExitExcusedSoundFile"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of SoundList" [ngClass]="o.SchoolID > 0 ? 'scst-SchoolStyle' : 'scst-DistrictStyle'" [ngValue]="o.SoundFile">
						{{ o.SoundFile }}
					</option>
				</select>

				<div>
					<!-- <button class="btn btn-primary scst-LabelText" (click)="openSoundMaintenance()">...</button> -->
					<button class="btn btn-primary scst-LabelText" (click)="PlaySoundEarlyExitExcused()">Play</button>
					<button class="btn btn-primary scst-LabelText" (click)="StopSound()">Stop</button>
					<button class="btn btn-primary scst-LabelText" (click)="ClearEarlyExitExcusedSound()">Clear</button>
				</div>
			</div>
		</div>

		<h5>Block List Sound:</h5>
		<div class="scst-Grid2Row">
			<!--Sound options-->
			<div class="scst-Grid2Col">
				<select
					[disabled]="IsLoading() == true"
					class="form-control scst-LabelText"
					name="EarlyExitExcusedSoundFile"
					(ngModelChange)="onSoundChange()"
					[(ngModel)]="optionsData.BlockListSoundFile"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of SoundList" [ngClass]="o.SchoolID > 0 ? 'scst-SchoolStyle' : 'scst-DistrictStyle'" [ngValue]="o.SoundFile">
						{{ o.SoundFile }}
					</option>
				</select>

				<div>
					<!-- <button class="btn btn-primary scst-LabelText" (click)="openSoundMaintenance()">...</button> -->
					<button class="btn btn-primary scst-LabelText" (click)="PlaySoundBlockList()">Play</button>
					<button class="btn btn-primary scst-LabelText" (click)="StopSound()">Stop</button>
					<button class="btn btn-primary scst-LabelText" (click)="ClearBlockListSound()">Clear</button>
				</div>
			</div>
		</div>
	</div>

	<!--District Sound Menu-->
	<div class="scst-Menu" *ngIf="DistrictUser()">
		<div class="scst-Flex">
			<h5>Invalid Card Sound:</h5>
			<h5 class="scst-HelpTextH5">(This effects the whole district, however each ScanStation can override this sound)</h5>
		</div>

		<!--Options-->
		<div class="scst-Grid2Row">
			<!--Sound options-->
			<div class="scst-Grid2Col">
				<select
					[disabled]="IsLoading() == true"
					class="form-control scst-LabelText"
					name="InvalidCardSoundFile"
					(ngModelChange)="onSoundChange()"
					[(ngModel)]="optionsData.InvalidCardSoundFile"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of SoundList" [ngClass]="o.SchoolID > 0 ? 'scst-SchoolStyle' : 'scst-DistrictStyle'" [ngValue]="o.SoundFile">
						{{ o.SoundFile }}
					</option>
				</select>

				<div>
					<button class="btn btn-primary scst-LabelText" (click)="PlaySoundInvalidCard()">Play</button>
					<button class="btn btn-primary scst-LabelText" (click)="StopSound()">Stop</button>
					<button class="btn btn-primary scst-LabelText" (click)="ClearInvalidSound()">Clear</button>
				</div>
			</div>
		</div>
	</div>

	<!--Behavior (From Calendar Maintenance Screen)-->
	<div class="scst-Menu">
		<h5>Scanstation Behavior:</h5>

		<!--Behavior Dropdown-->
		<div class="scst-Grid2Col">
			<label class="scst-LabelText">Behavior:</label>
			<select [disabled]="IsLoading() == true" class="form-control scst-LabelText" name="BehaviorID" [(ngModel)]="optionsData.BehaviorID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of BehaviorList" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>
</div>

<!--Button Panel-->
<div class="scst-Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="form-group scst-TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
